import { ChipContainer } from './styles';
import { ChipProps } from './types';

export const Chip = ({
	label,
	$color,
	$bgColor,
	$hasBorder,
	onClick,
	'data-testid': dataTestId = 'chip'
}: ChipProps) => {
	return (
		<ChipContainer $bgColor={$bgColor} $color={$color} $hasBorder={$hasBorder} onClick={onClick} data-testid={dataTestId} data-label={label}>
			{label}
		</ChipContainer>
	);
};
